import { PrepJobResponse } from "@deliverr/prep-service-client";

/**
 * Extracts and consolidates prep instructions from a given prep job response.
 *
 * @param {PrepJobResponse} [prepJob] - The prep job response object which may contain a note with preparation types.
 * @returns {string[]} An array of prep instructions extracted from the note, or an empty array.
 */
export const getConsolidatedPrepInstructionFromPrepJob = (prepJob?: PrepJobResponse): string[] => {
  if (!prepJob) {
    return [];
  }

  return prepJob.note?.split(" | ") ?? [];
};
